<template>
  <div class="broadcast-list-filters">
    <img src="~@/assets/icon-filter.svg">
    <div
      v-for="type in orderedBroadcastTypes"
      :key="type"
      class="broadcast-type-filter"
      :class="{
        disabled: !isBroadcastTypeAvailable(type),
        excluded: isBroadcastTypeExcluded(type),
      }"
      @click="toggleFilter(type)"
    >
      {{ type }}
      <img
        v-if="isBroadcastTypeAvailable(type) && !isBroadcastTypeExcluded(type)"
        src="~@/assets/icon-checkbox.svg"
      >
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'BroadcastListFilters',
  data() {
    return {
      broadcastTypes: ['FM', 'HD', 'DAB', 'AM'],
    };
  },
  computed: {
    ...mapState('customMarket', ['broadcastExcludedTypes']),
    ...mapGetters('customMarket', [
      'isBroadcastTypeExcluded', 'isBroadcastTypeAvailable',
    ]),
    orderedBroadcastTypes() {
      return _.sortBy(this.broadcastTypes, type => (this.isBroadcastTypeAvailable(type) ? 0 : 1));
    },
  },
  methods: {
    ...mapMutations('customMarket', ['toggleBroadcastTypeFilter']),
    toggleFilter(type) {
      if (!this.isBroadcastTypeAvailable(type)) return;
      this.toggleBroadcastTypeFilter(type);
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/variables";

.broadcast-list-filters {
  display: flex;
  align-items: center;
}

.broadcast-type-filter {
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  width: 64px;
  height: 27px;

  margin-left: 8px;
  border: 1px solid #4D4D4D;
  padding: 5px 8px;
  border-radius: 2px;
  width: 64px;
  height: 27px;
  font-size: 12px;
  line-height: 15px;
  font-weight: $weight-black;
  color: white;
  background: #4a4a4a;
  cursor: pointer;

  &.excluded {
    background-color: rgba(0,0,0,0.05);
  }

  &.disabled {
    cursor: not-allowed;
  }
}
</style>
